export const floatingButtonDefaults = {
  floatingButtonText: 'Button',
  floatingButtonPosition: {
    position: 'bottom-right',
    verticalOffset: 20,
    horizontalOffset: 20
  },
  floatingButtonMode: 'contain',
  floatingButtonColor: 'rgb(25, 123, 255)',
  floatingButtonFontColor: 'rgb(255, 255, 255)',
  floatingButtonCornerRadius: 32,
  floatingButtonFontStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    fontStyle: 'normal'
  },
  floatingButtonHorizontalPadding: 23,
  floatingButtonVerticalPadding: 12,
  floatingButtonAnimationEnabled: false,
  floatingButtonAnimationInterval: 10,
  floatingButtonSize: 24
};

export type FloatingButtonSettings = typeof floatingButtonDefaults;
